import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DadoAdicionalItemService {
  constructor(private http: HttpClient) {}

  index(): Observable<any[]> {
    return this.http.get<any[]>(environment.apiUrl + '/dados-adicionais-item');
  }
  tipos(): Observable<any[]> {
    return this.http.get<any[]>(environment.apiUrl + '/dados-adicionais-item-tipos');
  }
  casasDecimais(): Observable<any[]> {
    return this.http.get<any[]>(environment.apiUrl + '/dados-adicionais-item-casas-decimais');
  }
  ativoLista(): Observable<any[]> {
    return this.http.get<any[]>(environment.apiUrl + '/dados-adicionais-item-ativo-lista');
  }
  show(id: number): Observable<{}> {
    return this.http.get(environment.apiUrl + '/dados-adicionais-item/' + id);
  }
  store(model: {}): Observable<{}> {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    return this.http.post<{}>(environment.apiUrl + '/dados-adicionais-item',
      model,
      { headers: headers }
    );
  }
  update(model: {}): Observable<{}> {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    return this.http.put<{}>(environment.apiUrl + '/dados-adicionais-item/' + model['id'],
      model,
      { headers: headers }
    );
  }
  delete(id: number): Observable<{}> {
    return this.http.delete<{}>(environment.apiUrl + '/dados-adicionais-item/' + id);
  }
}
